'use client';

import { Toast, ToastProvider, ToastViewport, useToast } from '.';

/**
 * A global toast provider. Should be used once in the app.
 * @see {@link https://stylus.design/toast}
 */
export const Toaster = () => {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, onDismiss, ...props }) => {
        return (
          <Toast key={id} onDismiss={onDismiss} title={title} description={description} {...props}>
            {action}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
};
